`use strict`;

class Draad_Lightbox {

	constructor( slider ) {
		this.slider = slider;
		this.sliderEvents();
	}

	sliderEvents() {
		const sliderSectionID = this.slider.dataset.dialogSlider;
		const section = document.querySelector(`section.--lightbox[data-slider-section="${sliderSectionID}"]`);

		const sectionMedia = section.querySelectorAll('.card');
		const swiper = this.slider.swiper;

		// Attach event listener to dialog items
		sectionMedia.forEach( function ( media ) {
			media.addEventListener( 'click', handledialogItemClick );
		} );

		// Event listener for dialog item click
		function handledialogItemClick() {
			// get data of the current item that is clicked and let swiper slide to the desired slide
			const dialogSlide = this.dataset.dialogSlide;
			swiper.slideTo( dialogSlide );
		}
	}
}

document.addEventListener("DOMContentLoaded", () => {
	
	const dialogSliders = [];

	const dialogSlidersNodes = document.querySelectorAll('.slider.--lightbox');
	dialogSlidersNodes.forEach( function ( slider ) {

		dialogSliders.push( new Draad_Lightbox( slider ) );

	});

});